module.exports = __webpack_public_path__ + "img/left_6_hover.760376b9.png";